import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <>
      {/* Footer */}
      <footer className="bg-slate-900 text-gray-300">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8 mb-12">
            {/* Company Info */}
            <div className="lg:col-span-2">
              <img src='/assets/img/brand/logo-light.png' alt='Legal Trademark Solutions Logo' className='h-16 mb-4' />
              <p className="text-sm text-gray-400 leading-relaxed mb-4">
                Your trusted partner for trademark registration and intellectual property protection services across the United States.
              </p>
              <div className="space-y-2 text-sm text-gray-400">
                <div>📧 info@legaltrademarksolutions.com</div>
                <div>📞 +1 (888) 472 1093</div>
                <div>📍 3435 Wilshire Blvd, Los Angeles, CA 90010</div>
                <div>🕐 Mon-Fri: 9AM-6PM EST</div>
              </div>
            </div>

            {/* Trademark Services */}
            <div>
              <h4 className="text-white font-semibold mb-4">Trademark</h4>
              <ul className="space-y-2">
                <li><Link to="/services/trademark-registration" className="text-sm hover:text-teal-400 transition-colors">Registration</Link></li>
                <li><Link to="/services/clearance-search" className="text-sm hover:text-teal-400 transition-colors">Clearance Search</Link></li>
                <li><Link to="/services/trademark-renewal" className="text-sm hover:text-teal-400 transition-colors">Renewal</Link></li>
                <li><Link to="/services/office-actions" className="text-sm hover:text-teal-400 transition-colors">Office Actions</Link></li>
                <li><Link to="/services/infringement-monitoring" className="text-sm hover:text-teal-400 transition-colors">Monitoring</Link></li>
                <li><Link to="/services/trademark-disputes" className="text-sm hover:text-teal-400 transition-colors">Disputes</Link></li>
              </ul>
            </div>

            {/* Copyright & Patent */}
            <div>
              <h4 className="text-white font-semibold mb-4">Copyright & Patent</h4>
              <ul className="space-y-2">
                <li><Link to="/services/copyright-registration" className="text-sm hover:text-teal-400 transition-colors">Copyright Registration</Link></li>
                <li><Link to="/services/copyright-enforcement" className="text-sm hover:text-teal-400 transition-colors">Copyright Enforcement</Link></li>
                <li><Link to="/services/patent-search" className="text-sm hover:text-teal-400 transition-colors">Patent Search</Link></li>
                <li><Link to="/services/patent-application" className="text-sm hover:text-teal-400 transition-colors">Patent Application</Link></li>
              </ul>
            </div>

            {/* Company Services */}
            <div>
              <h4 className="text-white font-semibold mb-4">Company Services</h4>
              <ul className="space-y-2">
                <li><Link to="/services/llc-formation" className="text-sm hover:text-teal-400 transition-colors">LLC Formation</Link></li>
                <li><Link to="/services/c-corporation" className="text-sm hover:text-teal-400 transition-colors">C Corporation</Link></li>
                <li><Link to="/services/s-corporation" className="text-sm hover:text-teal-400 transition-colors">S Corporation</Link></li>
                <li><Link to="/services/bookkeeping" className="text-sm hover:text-teal-400 transition-colors">Bookkeeping</Link></li>
                <li><Link to="/services/tax-advisory" className="text-sm hover:text-teal-400 transition-colors">Tax Advisory</Link></li>
              </ul>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-white font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li><Link to="/" className="text-sm hover:text-teal-400 transition-colors">Home</Link></li>
                <li><Link to="/about" className="text-sm hover:text-teal-400 transition-colors">About Us</Link></li>
                <li><Link to="/contact" className="text-sm hover:text-teal-400 transition-colors">Contact Us</Link></li>
                <li><Link to="/privacy-policy" className="text-sm hover:text-teal-400 transition-colors">Privacy Policy</Link></li>
                <li><Link to="/terms-of-service" className="text-sm hover:text-teal-400 transition-colors">Terms of Service</Link></li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-gray-800 pt-8 mt-8">
            <div className="text-center">
              <p className="text-sm text-gray-400">© 2026 Legal Trademark Solutions. All rights reserved.</p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;